import { BookingAuditSearchItemFragment as BookingFragment } from "@graphql";
import { Row, Item, Filter } from "../utils";

export { BookingFragment };
export type ItemType = Item<BookingFragment>;
export type RowType = Row<Item<BookingFragment>>;

export const hiddenFilterFields: Array<keyof Filter> = [
  "bookingStatus",
  "consultants",
  // "costCenter",
  "customerGroup",
  "organizationType",
  "responsiblePersonId",
  "specialization",
  "text",
  "timeReportStatus",
  "systems"
];
